 const data = [
    
    {
        title : "DEVENEZ UN EXPERT EN SAGE GESTION COMMERCIALE EN 136 VIDEOS",
        videoAccueilID :"pEcO7Bhv7mk",
        description :"Apprenez à votre rythme : Chaque vidéo vous guide pas à pas dans les fonctionnalités essentielles de Sage 100c, de la configuration à l’utilisation quotidienne. Formation complète et pratique : De la création de documents commerciaux à l’analyse de vos ventes, chaque aspect de la gestion commerciale est couvert de manière claire et détaillée.",
        lienPlaylistYoutube:"https://www.youtube.com/playlist?list=PLGASACx6MSOt8XEBcnqrbnaxgGUrksRrG",
        freeNumber :"36"
    },
    {
        title : "FORMATION COMPLETE EN SAGE COMPTABILITE i7 EN 29 VIDEOS",
        videoAccueilID :"oSdHZXfkFwY",
        description :"Maîtrisez Sage Comptabilité i7 en 29 vidéos et découvrez chaque étape clé du workflow comptable, de la saisie à la clôture des comptes. Optimisez vos processus pour une comptabilité plus fluide et une gestion efficace de vos finances.ans cette formation, vous risquez de stagner dans votre carrière et de manquer des compétences essentielles à la réussite professionnelle dans le domaine de la comptabilité. Ne laissez pas passer cette opportunité de vous démarquer !",
        lienPlaylistYoutube:"https://www.youtube.com/playlist?list=PLGASACx6MSOuShQ-y8-LsDT3_O_9zlHtl",
        freeNumber :"10"
    },
    {
        title : "MAITRISEZ LE LOGICIEL SAGE PAIE & RH I7 EN 40 VIDEOS",
        videoAccueilID :"lZhNEdz5HaA",
        description :"Vous rêvez de paramétrer et de générer automatiquement vos bulletins de paie ainsi que votre DIPE magnétique CNPS ? Cette formation est faite pour vous !",
        lienPlaylistYoutube:"https://www.youtube.com/playlist?list=PLGASACx6MSOtTkhk0Xy-dRG-sy6amZ4cg",
        freeNumber :"16"
    },
    {
        title : "MAITRISEZ LE PARAMATRAGE ET LA GESTION DES CONGES PAYES AVEC SAGE PAIE & RH i7",
        videoAccueilID :"VnjLlz7Od64",
        description :"Maîtrisez la théorie, le paramétrage et la gestion des congés payés avec Sage Paie & RH i7 ! Découvrez étape par étape dans cette playlist comment configurer les congés payés de A à Z, optimisant ainsi la gestion de votre paie. Ne ratez pas cette occasion de vous perfectionner et de propulser votre carrière dans la gestion des ressources humaines !",
        lienPlaylistYoutube:"https://www.youtube.com/playlist?list=PLGASACx6MSOuTQdcX6esbhf6XEitiN_XA",
        freeNumber :"04"
        
    },
    {
        title : "GERER EFFICACEMENT LES ABSENCES ET LES CONGES AVEC SAGE PAIE & RH",
        videoAccueilID :"1GVoI6nUefE",
        description :"La formation en gestion des absences et ancienneté est le complément idéal à vos compétences en Sage et RH i7. Apprenez à gérer efficacement les absences, à suivre l'ancienneté des employés et à optimiser la gestion des ressources humaines, pour une administration plus fluide et précise. Ce module vous permet de renforcer votre expertise et d’ajouter une dimension stratégique à vos connaissances Sage et RH, un atout essentiel pour évoluer dans votre carrière !",
        lienPlaylistYoutube:"https://www.youtube.com/playlist?list=PLGASACx6MSOuTQdcX6esbhf6XEitiN_XA",
        freeNumber :"03"
    },

]


export default data;